<template>
  <div class="contactView">
    <div class="lxwmTitle">
      <img class="image" src="./img/title.png"  alt="">
    </div>
     <div class="contactBt lxwmTitle">
       <!-- <img class="image" src="./img/bigTitle.png" alt=""> -->
       联系我们
     </div>
     <div class="zkzg lxwmTitle ">
        <img src="./img/titleMap.png" class="zhzgImg" alt="">
        <div class="contactWay">
          <div class="contactN" >
            <div class="contactWayTitle" >公司联系方式</div>
            <!-- <div class="contactCentent" ><img src="./img/icon.png" alt=""><span class="contactCententS">zsh424@126.com</span></div> -->
            <div class="contactCentent" ><img src="./img/xp.png" alt=""> <span class="contactCententS">400-991-9533</span></div>
            <div class="contactCentent" ><img src="./img/xd.png" alt=""><span class="contactCententS">郑州市中科智谷12号楼7层</span></div>
            <!-- <div class="contactCentent" ><img src="./img/xt.png" alt=""><span class="contactCententS">工作时间9:00/12:00-13:30/17:30</span></div> -->
          </div>
        </div>
     </div>
     <div class="contactMap lxwmTitle ">
          <!-- <img src="./img/Map.png"  class="zhzgImg" alt=""> -->
        <BaiDuMap/>
      </div>
  </div>
</template>

<script>
import BaiDuMap from '@/components/BaiDuMap/BaiDuMap.vue'
export default {
  name: 'contactView',
  components: {
    BaiDuMap
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.contactView{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: #fff;
  .image{
    width: 100%;
    height: 100%;
  }
  .contactBt{
    width: 100%;
    font-size: 32px/$md;
    font-weight: 400;
    color: #000000;
    margin: 40px/$md 0;
    text-align: center;
  }
  .zkzg{
    width: 690px/$md;
    height: 306px/$md;
    position: relative;
    margin-bottom: 40px/$md;
    .zhzgImg{
        width: 347px/$md;
        height: 232px/$md;
    }
    .contactWay{
    position: absolute;
    bottom: 0;
    right: 0;
    width: 408px/$md;
    height: 202px/$md;
    background: #FFFFFF;
    box-shadow: 0px/$md .125rem .625rem rgba(0,0,0,0.1);
    padding: 40px/$md 0 0 35px/$md;
    // box-sizing: border-box;
    .contactN{
      // height: 100%;
    }
    .contactCentent{
    display: flex;
    align-items: center;
    margin-bottom: 25px/$md;
    // height: 20px/$md;
    img{
        width: 18px/$md;
        height: 18px/$md;
    }
    .contactCententS{
      padding-left: 8px/$md;
      font-size: 20px/$md;
      // width: 304px/$md;
    }
//   }
  }

   .contactWayTitle{
    margin-bottom: 31px/$md;
    font-size: 24px/$md;
    font-weight: bold;
    color: #333333;

    }
  }
  }
  .contactMap{
    display: flex;
    justify-content: center;
    width: 690px/$md;
    height: 239px/$md;
    margin-bottom: 50px/$md;
  }
}

</style>
